import styled from "styled-components";

export default styled.div`
	margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/common/fragments/FormSection.tsx